import React from 'react';
import Container from "./Container";
import AssetGroup from "./AssetGroup";

const Category = ({ category, showDecommissioned, selectedAsset, onSelectAsset, dependenciesOfSelected, dependentsOfSelected }) => (
  <Container
    className='category'
    icon={category.icon}
    title={category.name}
  >
    {
      category.groups.filter(
        ag => showDecommissioned || !ag.decommissioned
      ).map(
        group => (
          <AssetGroup
            key={group.id}
            group={group}
            showDecommissioned={showDecommissioned}
            selectedAsset={selectedAsset}
            onSelectAsset={onSelectAsset}
            containsGroups={group.assetGroups && group.assetGroups.length > 0}
            dependenciesOfSelected={dependenciesOfSelected}
            dependentsOfSelected={dependentsOfSelected}
          />
        )
      )
    }
  </Container>
);

export default Category;
